import * as React from 'react';
import { useSelector } from 'react-redux';

import { IModalWithContactsProps, ModalWithContacts } from '../../components/ModalWithContacts';
import {
  getBuilder,
  getName,
  getPriceForMeterFromDeveloperDisplay,
  getPriceForObjectFromDeveloperDisplay,
} from '../../selectors/newbuilding';
import { ModalCallButton } from '../Call/ModalCallButton';
import { SecondaryCallbackButton } from '../CallbackButton';
import { ACTIONS_MAP, TPlaceType } from './constants';

interface IModalWithContactsContainerProps extends Pick<IModalWithContactsProps, 'open' | 'onClose' | 'children'> {
  placeType: TPlaceType;
}

export const ModalWithContactsContainer = ({
  children,
  open,
  onClose,
  placeType,
}: IModalWithContactsContainerProps) => {
  const name = useSelector(getName);
  const price = useSelector(getPriceForObjectFromDeveloperDisplay);
  const pricePerMeter = useSelector(getPriceForMeterFromDeveloperDisplay);
  const builder = useSelector(getBuilder);

  const displayPrice = React.useMemo(() => price.replace(' до', '\nдо'), [price]);
  const { callAction, callbackOpener } = ACTIONS_MAP[placeType];

  return (
    <ModalWithContacts
      open={open}
      onClose={onClose}
      name={`ЖК ${name}`}
      price={displayPrice}
      pricePerMeter={pricePerMeter}
      builderName={builder.name}
      contactsButton={<ModalCallButton callAction={callAction} placeType={placeType} />}
      callbackButton={<SecondaryCallbackButton placeType={callbackOpener} />}
    >
      {children}
    </ModalWithContacts>
  );
};
